import React from "react"
import { Label } from "semantic-ui-react"
import Price from "components/Price/Price";

const LabelSale = ( { percent, price, strike = true } ) => <Label size="tiny" color={"green"}>{percent}&nbsp;<span
  className={`f7 white-80 ${strike ? "strike" : ""}`}><Price>{price}</Price></span></Label>

export default LabelSale


// WEBPACK FOOTER //
// ./src/components/Product/LabelSale.js